import FileSelector from "./FileSelector";
import ReactStars from "react-rating-stars-component";
import RangeExt from "./RangeExt";
import EmojiSection from "./EmojiSection";

import { ReactComponent as StarIcon } from "../assets/icons/starIcon.svg";
import { ReactComponent as EmptyStarIcon } from "../assets/icons/emptyStarIcon.svg";
import React from "react";
import { useTranslation } from "react-i18next";
import { Add, DocumentText, Microphone2 } from "iconsax-react";

export default function CriteriaSorter({
    criteriaList,
    parent = null,
    noteHandle,
    openTextBoxID,
    setTextBoxID,
    fileSelectorHandle,
    setRecordBoxID,
    criteriaStateHandle,
    criteriaReplies,
    voiceFileHandle,
    onlyCriteriaId = null,
}) {
    const { t, i18n } = useTranslation();

    return (
        <>
            {criteriaList
                .filter((e) =>
                    onlyCriteriaId
                        ? e.id === onlyCriteriaId
                        : e.criteria.parent === parent
                )
                .map((r, index) => {
                    const reply = criteriaReplies.filter(
                        (e) => e.criteria === r.id
                    )[0];
                    const isDescriptionOpen = openTextBoxID === r.id;

                    return (
                    <div key={index}>
                        <div className="criteria">
                            <div className="rating-clean-btn">
                                <p>{r.criteria.name}</p>
                                <div className="rating-btn">
                                    {r.add_description ? (
                                        <button
                                            className={
                                                reply?.description ||
                                                isDescriptionOpen
                                                    ? "selected"
                                                    : ""
                                            }
                                            onClick={() =>
                                                setTextBoxID(
                                                    isDescriptionOpen
                                                        ? -1
                                                        : r.id
                                                )
                                            }
                                        >
                                            <DocumentText />
                                        </button>
                                    ) : null}
                                    {r.add_upload_file ? (
                                        <button
                                            className={
                                                reply?.files ? "selected" : ""
                                            }
                                        >
                                            <FileSelector
                                                fileId={r.id}
                                                files={(e) =>
                                                    fileSelectorHandle(r.id, e)
                                                }
                                                multiple
                                            />
                                        </button>
                                    ) : null}
                                    <button
                                        className={
                                            reply?.voice ? "selected" : ""
                                        }
                                        onClick={() => setRecordBoxID(r.id)}
                                    >
                                        <Microphone2 />
                                    </button>
                                </div>
                            </div>
                            {r.add_description && isDescriptionOpen ? (
                                <div className="clean-star-input criteria-description-input">
                                    <div>
                                        <textarea
                                            placeholder={t("note.label")}
                                            value={reply?.description || ""}
                                            rows={3}
                                            autoFocus
                                            onChange={(e) =>
                                                noteHandle(
                                                    e.target.value,
                                                    r.id
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            ) : null}
                            {r.criteria_state_type === 1 ? (
                                <>
                                    <div>
                                        <div className="rating-button">
                                            {r.states
                                                .sort(
                                                    (a, b) => a.value - b.value
                                                )
                                                .map((c, innerIndex) => (
                                                    <button
                                                        onClick={() =>
                                                            criteriaStateHandle(
                                                                r.id,
                                                                c.value
                                                            )
                                                        }
                                                        className={
                                                            criteriaReplies.filter(
                                                                (e) =>
                                                                    e.criteria ===
                                                                    r.id
                                                            )[0]?.state ===
                                                            c.value
                                                                ? "selected"
                                                                : ""
                                                        }
                                                    >
                                                        {innerIndex + 1}
                                                    </button>
                                                ))}
                                        </div>
                                    </div>
                                    <div className="tag-bar">
                                        {criteriaReplies.filter(
                                            (e) => e.criteria === r.id
                                        )[0].voice ? (
                                            <div className="tag-list">
                                                <div
                                                    onClick={() => {
                                                        voiceFileHandle(
                                                            "",
                                                            true,
                                                            r.id
                                                        );
                                                    }}
                                                >
                                                    <Add
                                                        size={16}
                                                        className="close-btn"
                                                    />
                                                </div>
                                                <div>{t("voice.label")}</div>
                                            </div>
                                        ) : null}
                                        {criteriaReplies.filter(
                                            (e) => e.criteria === r.id
                                        )[0].files ? (
                                            <div className="tag-list">
                                                <div
                                                    onClick={() => {
                                                        fileSelectorHandle(
                                                            r.id,
                                                            "",
                                                            true
                                                        );
                                                    }}
                                                >
                                                    <Add
                                                        size={16}
                                                        className="close-btn"
                                                    />
                                                </div>
                                                <div>{t("file.label")}</div>
                                            </div>
                                        ) : null}
                                    </div>
                                </>
                            ) : null}
                            {r.criteria_state_type === 2 ? (
                                <>
                                    <div>
                                        <form>
                                            {r.states
                                                .sort(
                                                    (a, b) => a.value - b.value
                                                )
                                                .map((c, innerIndex) => (
                                                    <div
                                                        className="rating-check"
                                                        key={innerIndex}
                                                    >
                                                        <label>
                                                            {c.name}
                                                            <input
                                                                type="radio"
                                                                name={
                                                                    "checkbox" +
                                                                    r.id
                                                                }
                                                                onClick={() =>
                                                                    criteriaStateHandle(
                                                                        r.id,
                                                                        c.value
                                                                    )
                                                                }
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </div>
                                                ))}
                                        </form>
                                    </div>
                                    <div className="tag-bar">
                                        {criteriaReplies.filter(
                                            (e) => e.criteria === r.id
                                        )[0].voice ? (
                                            <div className="tag-list">
                                                <div
                                                    onClick={() => {
                                                        voiceFileHandle(
                                                            "",
                                                            true,
                                                            r.id
                                                        );
                                                    }}
                                                >
                                                    <Add
                                                        size={16}
                                                        className="close-btn"
                                                    />
                                                </div>
                                                <div>{t("voice.label")}</div>
                                            </div>
                                        ) : null}
                                        {criteriaReplies.filter(
                                            (e) => e.criteria === r.id
                                        )[0].files ? (
                                            <div className="tag-list">
                                                <div
                                                    onClick={() => {
                                                        fileSelectorHandle(
                                                            r.id,
                                                            "",
                                                            true
                                                        );
                                                    }}
                                                >
                                                    <Add
                                                        size={16}
                                                        className="close-btn"
                                                    />
                                                </div>
                                                <div>{t("file.label")}</div>
                                            </div>
                                        ) : null}
                                    </div>
                                </>
                            ) : null}
                            {r.criteria_state_type === 3 ? (
                                <>
                                    <EmojiSection
                                        states={r.states}
                                        selectedValue={
                                            criteriaReplies.filter(
                                                (e) => e.criteria === r.id
                                            )[0]?.state
                                        }
                                        onSelect={(value) =>
                                            criteriaStateHandle(r.id, value)
                                        }
                                        caption={
                                            r.states.filter(
                                                (e) =>
                                                    e.value ===
                                                    criteriaReplies.filter(
                                                        (e) =>
                                                            e.criteria === r.id
                                                    )[0]?.state
                                            )[0]?.name
                                        }
                                    />
                                    <div className="tag-bar">
                                        {criteriaReplies.filter(
                                            (e) => e.criteria === r.id
                                        )[0].voice ? (
                                            <div className="tag-list">
                                                <div
                                                    onClick={() => {
                                                        voiceFileHandle(
                                                            "",
                                                            true,
                                                            r.id
                                                        );
                                                    }}
                                                >
                                                    <Add
                                                        size={16}
                                                        className="close-btn"
                                                    />
                                                </div>
                                                <div>{t("voice.label")}</div>
                                            </div>
                                        ) : null}
                                        {criteriaReplies.filter(
                                            (e) => e.criteria === r.id
                                        )[0].files ? (
                                            <div className="tag-list">
                                                <div
                                                    onClick={() => {
                                                        fileSelectorHandle(
                                                            r.id,
                                                            "",
                                                            true
                                                        );
                                                    }}
                                                >
                                                    <Add
                                                        size={16}
                                                        className="close-btn"
                                                    />
                                                </div>
                                                <div>{t("file.label")}</div>
                                            </div>
                                        ) : null}
                                    </div>
                                </>
                            ) : null}
                            {r.criteria_state_type === 4 ? (
                                <>
                                    <div className="star">
                                        <ReactStars
                                            count={r.states.length}
                                            onChange={(value) =>
                                                criteriaStateHandle(
                                                    r.id,
                                                    r.states.sort(
                                                        (a, b) =>
                                                            a.value - b.value
                                                    )[value - 1].value
                                                )
                                            }
                                            size={30}
                                            activeColor="#FEB730"
                                            filledIcon={<StarIcon />}
                                            emptyIcon={<EmptyStarIcon />}
                                        />
                                    </div>
                                    <div className="tag-bar">
                                        {criteriaReplies.filter(
                                            (e) => e.criteria === r.id
                                        )[0].voice ? (
                                            <div className="tag-list">
                                                <div
                                                    onClick={() => {
                                                        voiceFileHandle(
                                                            "",
                                                            true,
                                                            r.id
                                                        );
                                                    }}
                                                >
                                                    <Add
                                                        size={16}
                                                        className="close-btn"
                                                    />
                                                </div>
                                                <div>{t("voice.label")}</div>
                                            </div>
                                        ) : null}
                                        {criteriaReplies.filter(
                                            (e) => e.criteria === r.id
                                        )[0].files ? (
                                            <div className="tag-list">
                                                <div
                                                    onClick={() => {
                                                        fileSelectorHandle(
                                                            r.id,
                                                            "",
                                                            true
                                                        );
                                                    }}
                                                >
                                                    <Add
                                                        size={16}
                                                        className="close-btn"
                                                    />
                                                </div>
                                                <div>{t("file.label")}</div>
                                            </div>
                                        ) : null}
                                    </div>
                                </>
                            ) : null}
                            {r.criteria_state_type === 5 ? (
                                <>
                                    <div className="range">
                                        <RangeExt
                                            max={r.states.length}
                                            states={r.states.sort(
                                                (a, b) => a.value - b.value
                                            )}
                                            value={(val) =>
                                                criteriaStateHandle(r.id, val)
                                            }
                                        />
                                    </div>
                                    <div className="tag-bar">
                                        {criteriaReplies.filter(
                                            (e) => e.criteria === r.id
                                        )[0].voice ? (
                                            <div className="tag-list">
                                                <div
                                                    onClick={() => {
                                                        voiceFileHandle(
                                                            "",
                                                            true,
                                                            r.id
                                                        );
                                                    }}
                                                >
                                                    <Add
                                                        size={16}
                                                        className="close-btn"
                                                    />
                                                </div>
                                                <div>{t("voice.label")}</div>
                                            </div>
                                        ) : null}
                                        {criteriaReplies.filter(
                                            (e) => e.criteria === r.id
                                        )[0].files ? (
                                            <div className="tag-list">
                                                <div
                                                    onClick={() => {
                                                        fileSelectorHandle(
                                                            r.id,
                                                            "",
                                                            true
                                                        );
                                                    }}
                                                >
                                                    <Add
                                                        size={16}
                                                        className="close-btn"
                                                    />
                                                </div>
                                                <div>{t("file.label")}</div>
                                            </div>
                                        ) : null}
                                    </div>
                                </>
                            ) : null}
                        </div>

                        {!onlyCriteriaId ? (
                            <div>
                                <CriteriaSorter
                                    criteriaList={criteriaList}
                                    parent={r.criteria.id}
                                    noteHandle={noteHandle}
                                    openTextBoxID={openTextBoxID}
                                    setTextBoxID={setTextBoxID}
                                    fileSelectorHandle={(id, file) =>
                                        fileSelectorHandle(id, file)
                                    }
                                    setRecordBoxID={(e) => setRecordBoxID(e)}
                                    criteriaStateHandle={(id, value) =>
                                        criteriaStateHandle(id, value)
                                    }
                                    criteriaReplies={criteriaReplies}
                                    voiceFileHandle={voiceFileHandle}
                                />
                            </div>
                        ) : null}
                    </div>
                    );
                })}
        </>
    );
}
